import { createFileRoute } from '@tanstack/react-router';

import StoreProductTypesPage from '@/components/store/product-types/Page';

export const Route = createFileRoute('/store/product-types/')({
	component: StoreProductTypesPage,
});
